import forEach from "lodash/forEach";
import values from "lodash/values";
import GroupEdgesSource from "Areas/Documents/graph/types/groupEdgesSource";
import filter from "lodash/filter";
import { findNodeById } from "./findNodeById";
import isEmpty from "lodash/isEmpty";
export default function createEdges({ graph, nodeMap, edgesSource, nodesSource, edgeMap }) {
    const edgeIdsCompleted = new Set();
    const edgesFromTo = new Set();
    forEach(values(edgesSource), edgeSource => {
        if (edgeMap.has(edgeSource.EdgeId)) {
            console.warn(`Связь с таким ID уже существует. ${edgeSource.EdgeId}. Пропуск создания.`);
            return;
        }
        if (edgesFromTo.has(edgeSource.EdgeId)) {
            console.warn(`Такая связь между ${edgeSource.From} и ${edgeSource.To} уже есть. Пропуск создания.`);
            return;
        }
        const { node: sourceNode } = findNodeById(nodeMap, nodesSource, edgeSource.From, edgeSource.FromGroup);
        const { node: targetNode, isGroup: targetNodeIsGroup } = findNodeById(nodeMap, nodesSource, edgeSource.To, edgeSource.ToGroup);
        if (sourceNode && targetNode) {
            try {
                let edge;
                if (targetNodeIsGroup) {
                    if (edgeIdsCompleted.has(edgeSource.EdgeId)) {
                        return;
                    }
                    const edgesForSameGroup = filter(edgesSource, e => {
                        const edgeId = e.EdgeId;
                        if (edgeIdsCompleted.has(edgeId)) {
                            return false;
                        }
                        const fromCondition = Boolean(edgeSource.From && edgeSource.From === e.From) ||
                            Boolean(edgeSource.FromGroup && edgeSource.FromGroup === e.FromGroup);
                        const toCondition = Boolean(edgeSource.To && edgeSource.To === e.To) ||
                            Boolean(edgeSource.ToGroup && edgeSource.ToGroup === e.ToGroup);
                        return fromCondition && toCondition;
                    });
                    if (isEmpty(edgesForSameGroup)) {
                        console.warn("Связь группы припушена: дочерних связей нет.", edgeSource);
                        return;
                    }
                    forEach(edgesForSameGroup, edgeForSameGroup => {
                        edgeIdsCompleted.add(edgeForSameGroup.EdgeId);
                    });
                    edge = graph.createEdge({
                        source: sourceNode,
                        target: targetNode,
                        tag: new GroupEdgesSource(targetNode.tag.id, edgesForSameGroup)
                    });
                }
                else {
                    edge = graph.createEdge({
                        source: sourceNode,
                        target: targetNode,
                        tag: {
                            ...edgeSource
                        }
                    });
                }
                edgesFromTo.add(`from:${edgeSource.From};to:${edgeSource.To}`);
                edgeIdsCompleted.add(edgeSource.EdgeId);
                edgeMap.set(edgeSource.EdgeId, edge);
            }
            catch (ex) {
                console.error(`Не удалось создать ребро между ${edgeSource.From} и ${edgeSource.To}`, ex);
            }
        }
        else {
            console.error(`Не удалось создать ребро между ${sourceNode} и ${targetNode}`);
        }
    });
}
